var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.9285 19.7615C28.3693 17.9282 26.976 16.6082 25.2252 16.214C24.7118 13.9223 23.3002 12.2815 21.3018 11.6582C19.1202 10.989 16.5902 11.6398 15.0043 13.299C13.6018 14.7565 13.1435 16.764 13.6843 18.8998C11.7318 19.3765 10.8335 21.0815 10.8335 22.6215C10.8335 24.3448 11.961 26.279 14.4727 26.4532H16.7918V24.0423C16.7918 22.8782 17.4885 22.1815 18.6527 22.1815H21.3477C22.5118 22.1815 23.2085 22.8782 23.2085 24.0423V26.4532H23.951C23.9602 26.4532 23.9785 26.4532 23.9877 26.4532C25.2893 26.4532 26.536 25.9673 27.4893 25.0965C28.9835 23.7948 29.5335 21.7507 28.9285 19.7615Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3473 22.1904H18.6523C17.4882 22.1904 16.7915 22.8871 16.7915 24.0513V26.7463C16.7915 27.9104 17.4882 28.6071 18.6523 28.6071H21.3473C22.5115 28.6071 23.2082 27.9104 23.2082 26.7463V24.0513C23.2082 22.8871 22.5115 22.1904 21.3473 22.1904ZM21.5307 25.5454L19.9998 27.2871L19.8165 27.4979C19.569 27.7821 19.3582 27.7088 19.3582 27.3238V25.6921H18.6615C18.3407 25.6921 18.2582 25.4996 18.469 25.2613L19.9998 23.5196L20.1832 23.3088C20.4307 23.0246 20.6415 23.0979 20.6415 23.4829V25.1146H21.3382C21.659 25.1054 21.7415 25.3071 21.5307 25.5454Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVa);
export default __webpack_public_path__ + "static/media/VA.d02cfd62.svg";
export { ForwardRef as ReactComponent };